import { OnboardingContainer } from './components/OnboardingContainer';
import { OnboardingWizard } from './components/OnboardingWizard';
import { SalesOnboardingContainer } from './components/SalesOnboardingContainer';
import { SalesOnboardingWizard } from './components/SalesOnboardingWizard';
import { CreateAccountState } from './hooks/useCreateAccount/types';

export { CreateAccountProvider, useCreateAccount, useIsContinueOnboardingEnabled, useOnboardingData } from './hooks';

export { OnboardingContainer, OnboardingWizard, SalesOnboardingContainer, SalesOnboardingWizard };
export type { CreateAccountState };
